import { render, staticRenderFns } from "./intro-index.vue?vue&type=template&id=9121085a"
import script from "./intro-index.vue?vue&type=script&lang=js"
export * from "./intro-index.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports